module.exports = __webpack_public_path__ + "static/media/bill_summary.097afac6.svg";